import { Outlet } from 'react-router-dom';

import { BasicLayout, BasicLayoutContent } from '@/components/BasicLayouts/BasicLayouts';

import s from './LogbookPage.module.scss';

/**
 * The logbook's shell.
 *
 * It used to carry a tab strip over the five books and redirect `/manage/logs`
 * onto whichever one the viewer could open. Both jobs have moved to places that
 * hold them better: the index page lists the books and says how each one stands,
 * and the Manage breadcrumb's switcher is what you switch between them with.
 */
export default function LogbookPage() {
  return (
    <BasicLayout>
      <BasicLayoutContent className={s.content}>
        <Outlet />
      </BasicLayoutContent>
    </BasicLayout>
  );
}
